import { render } from "./EventDevices.vue?vue&type=template&id=b1dc8122"
import script from "./EventDevices.vue?vue&type=script&lang=js"
export * from "./EventDevices.vue?vue&type=script&lang=js"

import "./EventDevices.vue?vue&type=style&index=0&id=b1dc8122&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__